import React from 'react';
import styled from 'styled-components';
//
import Debug from './debug';
import BlackBox from './render/black-box';
import Giphy from './render/giphy';
import Image from './render/image';
import RichText from './render/rich-text';
import ShowProps from './render';
import Subscribe from './render/subscribe';
import Thumbnail from './render/thumbnail';
import VideoEmbed from './render/video-embed';
import VimeoEmbed from './render/vimeo-embed';
//
export {
  BlackBox,
  Giphy,
  Image,
  RichText,
  ShowProps,
  Subscribe,
  Thumbnail,
  VideoEmbed,
  VimeoEmbed
};
//
export const RenderSlice = ({ slice_type, width, ...rest }) => {
  let w = width || 4;
  let component = null;

  switch (slice_type) {
    case 'black_box':
      component = <BlackBox {...rest} />;
      break;

    case 'embed_video':
      component = <VideoEmbed {...rest} />;
      break;

    case 'giphy_html5_video':
      component = <Giphy {...rest} />;
      break;

    case 'image':
      component = <Image {...rest} />;
      break;

    case 'mailchimp_subscribe':
      component = <Subscribe {...rest} />;
      break;

    case 'text':
      component = <RichText {...rest} />;
      break;

    case 'thumbnail':
      w = rest.thumbnail.width;
      component = <Thumbnail {...rest} />;
      break;

    default:
      component = <Debug slice_type={slice_type} {...rest} />;
  }

  return <SliceWrap width={w}>{component}</SliceWrap>;
};

// Loop through slices and pass props to RenderSlice
export const SlizeZone = props => {
  const { slices } = props;

  return (
    !slices || (
      <Wrap>
        {slices.map((slice, index) => (
          <RenderSlice key={index} {...slice} />
        ))}
      </Wrap>
    )
  );
};

// Export props as default
export default props => (
  <pre>
    <code>{JSON.stringify(props, null, 2)}</code>
  </pre>
);
//
const Wrap = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-gap: 1vw;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

const SliceWrap = styled.div`
  margin: 0 auto 1rem;

  @media (min-width: 768px) {
    grid-column: ${({ width }) => `span ${width}`};
    margin: 0;
  }
`;
